import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Spinner from "../../Layouts/Spinner";
import ReactSelect from "react-select";
import {
  addinvoice,
  getInvoiceList,
  getUserList,
} from "../../../redux/invoice/action";
import {
  addCreditNOteValidation,
  addInvoicesValidation,
} from "../../Constant/constant";
import professional from "../../assets/images/professional.png";
import { clientsDataList } from "../../../redux/user/action";
import AddClient from "../User/AddClient";
import { Modal } from "reactstrap";
import { getSettingsListAll } from "../../../redux/settings/action";
import { getOssClient } from "../../Common/Utils/ossUtils";

const AddDebitNotes = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [params, setParams] = useState({
    search_key: "",
    // page: 1
  });
  const settingsListData = useSelector(
    (state) => state?.reusableSlice?.settingsListData
  );

  const [selectDate, setSelectDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [param, setParam] = useState({
    parent_id: selectedOptions?.value,
  });
  const [invoiceDetails, setInvoiceDetails] = useState([
    {
      description: "",
      unit_price: 0,
      quantity: 1,
      vat_percent: 0,
      discount_percent: 0,
      product_id: "",
    },
  ]);

  const userList = useSelector((state) => state?.reusableSlice?.userList);
  const invoiceList = useSelector(
    (state) => state?.reusableSlice?.invoiceList?.invoices
  );
  const clientsData = useSelector(
    (state) => state?.reusableSlice?.getClientData
  );

  useEffect(() => {
    dispatch(clientsDataList(param));
  }, [dispatch, param]);

  useEffect(() => {
    setParam((prevState) => ({
      ...prevState,
      parent_id: selectedOptions?.value,
    }));
  }, [selectedOptions]);

  useEffect(() => {
    dispatch(getUserList({ search_key: "" }));
  }, [dispatch]);

  const handleAddInvoiceDetail = () => {
    const newDetail = {
      description: "",
      unit_price: "",
      quantity: 1,
      vat_percent: settingsListData.vat_percent,
      discount_percent: 0,
      product_id: "",
    };

    setInvoiceDetails([...invoiceDetails, newDetail]);
    formik.setFieldValue("invoice_detail", [
      ...(formik.values.invoice_detail || []),
      newDetail,
    ]);
  };

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    formik.setFieldValue("user_id", selected?.value);
    formik.setFieldValue("parent_type", "");
    formik.setFieldValue("parent_invoice_number", "");
    setSelectedClient("");
  };
  const handleChangeClient = (selected) => {
    setSelectedClient(selected);
    formik.setFieldValue("parent_type", selected?.value);
    formik.setFieldValue("parent_invoice_number", "");
    const data = {
      invoice_type: selected?.value,
      user_id: formik.values.user_id,
      per_page: 999,
    };
    dispatch(getInvoiceList(data));
  };

  const proOptions = userList?.users?.map((item) => ({
    value: item?.id,
    label: item?.full_name,
  }));

  const proClientOptions = [
    {
      value:0,
      label:"Simplified"
    },
    {
      value:1,
      label:"VAT"
    }, 
  ];

  useEffect(() => {
    settingsListData &&
      formik.setFieldValue(
        `invoice_detail[${0}].vat_percent`,
        settingsListData.vat_percent
      );
  }, [settingsListData]);

  useEffect(() => {
    dispatch(getSettingsListAll());
  }, [dispatch]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      invoice_detail: [
        {
          description: "",
          unit_price: "",
          quantity: 1,
          vat_percent: "",
          discount_percent: 0,
          product_id: "",
        },
      ],
      user_id: "",
      parent_type: "",
      invoice_type: "",
      reference_number: "",
      footer_text: "",
      logo: "",
      date_time: "",
      notes: "",
      time: "",
      parent_invoice_number: "",
    },
    validationSchema: addCreditNOteValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleLogoChange = async (event) => {
    const file = event.currentTarget.files[0];

    if (file) {
      const validImageTypes = [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/webp",
      ];

      if (!validImageTypes.includes(file.type)) {
        alert("Only image files (JPG, PNG, GIF, WebP) are allowed.");
        event.target.value = ""; // Reset the input
        return;
      }

      setImageLoading(true);
      const ossClient = await getOssClient();

      const fileName = `images/${Date.now()}_${file.name}`;

      const result = await ossClient.put(fileName, file, {
        progress: (p) => {
          setUploadProgress(Math.round(p * 100));
        },
        mimeType: file.type,
      });
      formik.setFieldValue("logo", result.url);
      formik.setFieldValue("logo", result.url);
      setImageLoading(false);
    }
  };
  const handledateChange = (e) => {
    const date = e.target.value;
    setSelectDate(date);
    updateDateTime(date, startTime);
  };

  const handleStartTime = (event) => {
    const time = event.target.value;
    setStartTime(time);
    updateDateTime(selectDate, time);
    formik.setFieldValue("time", time);
  };

  const updateDateTime = (date, time) => {
    if (date && time) {
      const dateTime = `${date} ${time}:00`;
      formik.setFieldValue("date_time", dateTime);
    } else {
      formik.setFieldValue("date_time", "");
    }
  };

  const handleIncrement = (index) => {
    const currentValue = formik.values.invoice_detail[index].quantity || 1;
    // if (currentValue < 10) {
    const updatedValue = currentValue + 1;
    formik.setFieldValue(`invoice_detail.${index}.quantity`, updatedValue);
    // }
  };

  const handleDecrement = (index) => {
    const currentValue = formik.values.invoice_detail[index].quantity || 1;
    if (currentValue > 1) {
      formik.setFieldValue(
        `invoice_detail.${index}.quantity`,
        currentValue - 1
      );
    }
  };

  const handleSubmit = async (values) => {
    try {
      const dateTime =
        selectDate && startTime ? `${selectDate} ${startTime}:00` : "";

      const data = {
        ...values,
        invoice_type: 4,
        date_time: dateTime,
      };
      dispatch(addinvoice(data, setLoading, navigate));
    } catch (error) {
      console.error("Submit Error:", error);
    }
  };

  const handleDeleteOneInvoice = (indexToDelete) => {
    setInvoiceDetails((prevDetails) =>
      prevDetails.filter((_, index) => index !== indexToDelete)
    );
  };
  return (
    <div className="px-4 pb-3 pt-5">
      <h3 className="pb-5">Create Debit Note</h3>
      <Modal isOpen={modal} toggle={() => setModal(!modal)}>
        <AddClient
          id={formik.values.user_id}
          modal={modal}
          setModal={setModal}
          params={params}
          setParams={setParams}
        />
      </Modal>
      <form onSubmit={formik.handleSubmit}>
        <div className="col-md-12  description-add">
          <div className="row">
            <div className="business-logo d-flex align-items-center col-md-12 form-group justify-content-center flex-column">
              <div className="profile-edit">
                {imageLoading ? (
                  <div className="loader-container">
                    <i className="fa fa-spinner fa-spin loader-icon"></i>{" "}
                  </div>
                ) : (
                  <img
                    src={formik.values.logo || professional}
                    alt="Business Logo"
                  />
                )}
                <label htmlFor="logo-upload" style={{ cursor: "pointer" }}>
                  <i className="fa fa-pencil"></i>
                </label>
              </div>
              <div className="text-center">
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  id="logo-upload"
                  onChange={handleLogoChange}
                />
                <span>Accept Image only</span>
              </div>
              {formik.touched.logo && formik.errors.logo ? (
                <div className="error">{formik.errors.logo}</div>
              ) : null}
            </div>

            <div className="col-md-4 form-group">
              <label>Customer</label>
              <ReactSelect
                value={selectedOptions}
                onChange={handleChange}
                options={proOptions}
                placeholder="select customer"
              />
              {formik.touched.user_id && formik.errors.user_id ? (
                <div className="error">{formik.errors.user_id}</div>
              ) : null}
            </div>

            <div className="col-md-4 form-group">
              <label>Date</label>
              <input
                type="date"
                className="form-control"
                value={selectDate}
                onChange={handledateChange}
              />
              {formik.touched.date_time && formik.errors.date_time ? (
                <div className="error">{formik.errors.date_time}</div>
              ) : null}
            </div>

            <div className="col-md-4 form-group">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <label className="m-0">Original Invocie Type</label>
              </div>
              <ReactSelect
                value={selectedClient}
                onChange={handleChangeClient}
                options={proClientOptions}
                placeholder="Select Original Invoice Type"
              />
                  {formik.touched.parent_type && formik.errors.parent_type ? (
                <div className="error">{formik.errors.parent_type}</div>
              ) : null}
            </div>

            {formik.values.parent_type === 0 && (
              <div className="col-md-4 form-group">
                <label>Client Name (Optional)</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter client name"
                  name="client_name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.client_name}
                />
              </div>
            )}

            <div className="col-md-4 form-group">
              <label>Select Original Invoice</label>
              <ReactSelect
                name="parent_invoice_number"
                id="parent_invoice_number"
                placeholder="Select an invoice"
                getOptionLabel={(option) => option.invoice_number}
                getOptionValue={(option) => option.invoice_number}
                options={invoiceList && invoiceList}
                onChange={(opions) => {
                  formik.setFieldValue(
                    "parent_invoice_number",
                    opions.invoice_number
                  );
                }}
                onBlur={formik.handleBlur}
                value={
                  invoiceList && invoiceList
                    ? invoiceList.filter(
                        (client) =>
                          formik.values.parent_invoice_number ===
                          client.invoice_number
                      )
                    : ""
                }
              />

              {formik.touched.parent_invoice_number &&
              formik.errors.parent_invoice_number ? (
                <div className="error">
                  {formik.errors.parent_invoice_number}
                </div>
              ) : null}
            </div>

            <div className="col-md-4 form-group">
              <label>Time</label>
              <input
                type="time"
                name="time"
                id="time"
                className="form-control w-100"
                placeholder="Enter start time"
                value={startTime}
                onChange={handleStartTime}
              />
              {formik.touched.time && formik.errors.time ? (
                <div className="error">{formik.errors.time}</div>
              ) : null}
            </div>

            <div className="col-md-4 form-group">
              <label>Reference Number</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Reference number"
                name="reference_number"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.reference_number}
              />
              {formik.touched.reference_number &&
              formik.errors.reference_number ? (
                <div className="error">{formik.errors.reference_number}</div>
              ) : null}
            </div>

            <div className="col-md-4 form-group">
              <label>Terms & Conditions</label>
              <textarea
                type="text"
                className="form-control"
                placeholder="Enter text"
                name="footer_text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.footer_text}
              />
              {formik.touched.footer_text && formik.errors.footer_text ? (
                <div className="error">{formik.errors.footer_text}</div>
              ) : null}
            </div>
            <div className="col-md-4 form-group">
              <label>Message & Notes</label>
              <textarea
                type="text"
                className="form-control"
                placeholder="Enter text"
                name="notes"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.notes}
              />
              {formik.touched.notes && formik.errors.notes ? (
                <div className="error">{formik.errors.notes}</div>
              ) : null}
            </div>
          </div>
          {invoiceDetails.map((detail, index) => (
            <div className="col-md-12  description-add" key={index}>
              <div className="row align-items-center">
                <React.Fragment key={index}>
                  <div className="col-md-5">
                    <div className="form-group">
                      <label>Description</label>
                      <textarea
                        style={{ height: "143px" }}
                        type="text"
                        className="form-control"
                        placeholder="Enter description"
                        name={`invoice_detail.${index}.description`}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={
                          formik.values.invoice_detail?.[index]?.description ||
                          ""
                        }
                      />
                      {formik.touched.invoice_detail?.[index]?.description &&
                      formik.errors.invoice_detail?.[index]?.description ? (
                        <div className="error">
                          {formik.errors.invoice_detail[index].description}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6 form-group">
                        <label>Product id</label>
                        <input
                          type="string"
                          className="form-control"
                          placeholder="Enter product id"
                          name={`invoice_detail.${index}.product_id`}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={
                            formik.values.invoice_detail?.[index]?.product_id ||
                            ""
                          }
                        />
                        {formik.touched.invoice_detail?.[index]?.product_id &&
                        formik.errors.invoice_detail?.[index]?.product_id ? (
                          <div className="error">
                            {formik.errors.invoice_detail[index].product_id}
                          </div>
                        ) : null}
                      </div>

                      <div className="col-md-6 form-group">
                        <label>Quantity</label>
                        <div className="input-group align-items-center">
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => handleDecrement(index)}
                          >
                            -
                          </button>
                          <p
                            style={{
                              width: "60px",
                              textAlign: "center",
                              fontFamily: "Aenoik-medium",
                              fontSize: "24px",
                            }}
                          >
                            {" "}
                            {formik.values.invoice_detail[index]?.quantity ||
                              1}{" "}
                          </p>
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => handleIncrement(index)}
                          >
                            +
                          </button>
                        </div>
                      </div>
                      <div className="col-md-4 form-group">
                        <label>Unit Price (SAR)</label>
                        <input
                          min="0"
                          type="number"
                          className="form-control"
                          placeholder="Enter unit price"
                          name={`invoice_detail.${index}.unit_price`}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={
                            formik.values.invoice_detail?.[index]
                              ?.unit_price !== undefined
                              ? formik.values.invoice_detail?.[index]
                                  ?.unit_price
                              : "" // fallback to "" when undefined
                          }
                        />
                        {formik.touched.invoice_detail?.[index]?.unit_price &&
                        formik.errors.invoice_detail?.[index]?.unit_price ? (
                          <div className="error">
                            {formik.errors.invoice_detail[index].unit_price}
                          </div>
                        ) : null}
                      </div>

                      <div className="col-md-4 form-group">
                        <label>Vat %</label>
                        <input
                          type="number"
                          max="100"
                          min="0"
                          disabled
                          className="form-control"
                          placeholder="Enter vat percent"
                          name={`invoice_detail.${index}.vat_percent`}
                          id={`invoice_detail.${index}.vat_percent`}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={
                            formik.values.invoice_detail?.[index]
                              ?.vat_percent !== undefined
                              ? formik.values.invoice_detail?.[index]
                                  ?.vat_percent
                              : ""
                          }
                        />
                        {formik.touched.invoice_detail?.[index]?.vat_percent &&
                        formik.errors.invoice_detail?.[index]?.vat_percent ? (
                          <div className="error">
                            {formik.errors.invoice_detail[index].vat_percent}
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-4 form-group">
                        <label>Discount %</label>
                        <input
                          type="number"
                          max="100"
                          min="0"
                          className="form-control"
                          placeholder="Enter discount percent"
                          name={`invoice_detail.${index}.discount_percent`}
                          id={`invoice_detail.${index}.discount_percent`}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={
                            formik.values.invoice_detail?.[index]
                              ?.discount_percent !== undefined
                              ? formik.values.invoice_detail?.[index]
                                  ?.discount_percent
                              : ""
                          }
                        />
                        {formik.touched.invoice_detail?.[index]
                          ?.discount_percent &&
                        formik.errors.invoice_detail?.[index]
                          ?.discount_percent ? (
                          <div className="error">
                            {
                              formik.errors.invoice_detail[index]
                                .discount_percent
                            }
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  {index > 0 && (
                    <div className="col-md-1">
                      <span
                        onClick={() => {
                          handleDeleteOneInvoice(index);
                        }}
                        className="border-button"
                        style={{ padding: "   6px 10px;" }}
                      >
                        {" "}
                        <span>
                          <i className=" fa fa-trash"></i>
                        </span>{" "}
                      </span>
                    </div>
                  )}
                </React.Fragment>
              </div>
            </div>
          ))}
          <div className="col-md-12 d-flex justify-content-end">
            <span
              className="border-button"
              onClick={handleAddInvoiceDetail}
              style={{ cursor: "pointer" }}
            >
              <span>+ Add More</span>
            </span>
          </div>
        </div>
        <div
          className="d-flex align-items-center justify-content-center mt-3  "
          style={{ columnGap: "20px" }}
        >
          <button
            className="submit-btn  "
            onClick={() => {
              navigate("/invoice");
            }}
            style={{ width: "max-content" }}
          >
            Back
          </button>
          <button
            className="submit-btn   "
            style={{ width: "max-content" }}
            type="submit"
          >
            {!loading ? "Submit" : <Spinner />}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddDebitNotes;
